


function ShowRewards({setdisplayreward,activerewards}) {

       // console.log(activerewards);
        let content;

        if (activerewards.reward_type === 1) {
             content = <p>{activerewards.reward_file}</p>;
        } else  if (activerewards.reward_type === 4) {
            content = (
                <audio controls>
                  <source src={activerewards.reward_file} type="audio/ogg" />
                  Your browser does not support the audio element.
                </audio>
              );
        }else if (activerewards.reward_type === 3 ) {

              if (activerewards.ftype === 'iframe' ) {
                content = (
                   
                     <iframe  width="640" height="360" frameborder="0"  title="video"  allowfullscreenallowFullScreen src={activerewards.reward_file}></iframe>
                   
                )   

              }else if (activerewards.ftype === 'videotag' ) {
                content = (
                        <video width="500" height="300" title="video" controls><source src={activerewards.reward_file} /></video>
                )
              }
               
        }   

        const gotoprizePage= (val) => {
             setdisplayreward(val);
    
        }; 
    return (
        <div>
            <div>{content}</div>
            <div className="w-full mt-[20px] mb-[20px] text-center">
              <button onClick={() => gotoprizePage(0)}  className="primary_btn_bg bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-white hover:text-[#0274F7] border hover:border-[#0274F7]">
                  Back
              </button>
             </div>
        </div>

    );
}

export default ShowRewards;
